export default class Header {
  constructor() {
    this.$header = $('#header');
    this.$search = $('.header__search');
    this.$searchInput = this.$search.find('input');
    this.$clearSearch = this.$search.find('.js-clear-search');
    this.$openSearch = $('.js-open-search');
    this.$closeSearch = this.$search.find('.header__search-close');
    this.$headerForm = $('.header__search-form');
    this.$searchBtn = this.$headerForm.find('.gg-news-hero__search-btn');
    this.$announcement = $('.header__announcement');
    this.$secondaryMenu = $('.header__secondary-menu');
    this.heightAnnouncement = 0;
    this.heightSecondaryMenu = 0;
    this.totalHeaderHeight = 0;
    this.numberScroll = 0;
    this.scrollTop = 0;
    this.lastScrollTop = 0;
    // Minimum scroll distance to trigger hide/show
    this.scrollThreshold = 100;
    this.classes = {
      pin: 'pin-header',
      searchActive: 'search-active',
      menuOpen: 'is-open-menu',
      active: 'active',
      hidden: 'hidden',
      disabled: 'disabled hidden',
      headerHidden: 'header-hidden',
      pointerEventNone: 'pointer-events-none',
    };

    this.handleScroll = this.debounce(this.settingPin.bind(this), 0);
    this.handleScrollDirection = this.debounce(this.handleScrollDirectionChange.bind(this), 10);
  }

  init() {
    if (this.$header.length) {
      this.setAnnouncementHeight();
      this.setSecondaryMenuHeight();
      this.controlSearchHeader();
      this.initScrollDirection();
      this.$header.addClass('loaded');
      // Update announcement height on resize
      $(window).on('resize.header', () => {
        this.setAnnouncementHeight();
        this.setSecondaryMenuHeight();
      });
      $(window).on('scroll.header resize.header', () => {
        this.settingPin();
      });
    }
  }

  setAnnouncementHeight() {
    if (this.$announcement.length) {
      const height = this.$announcement.outerHeight();
      document.documentElement.style.setProperty('--height-announcement', `${height}px`);
      this.heightAnnouncement = height;
    } else {
      document.documentElement.style.setProperty('--height-announcement', '0px');
      this.heightAnnouncement = 0;
    }
    this.updateTotalHeaderHeight();
  }

  setSecondaryMenuHeight() {
    if (this.$secondaryMenu.length) {
      const height = this.$secondaryMenu.outerHeight();
      this.heightSecondaryMenu = height;
    } else {
      this.heightSecondaryMenu = 0;
    }
    this.updateTotalHeaderHeight();
  }

  updateTotalHeaderHeight() {
    this.totalHeaderHeight = this.heightAnnouncement + this.heightSecondaryMenu;
  }

  initScrollDirection() {
    this.lastScrollTop = $(window).scrollTop();
    $(window).on('scroll.header', () => {
      this.handleScrollDirection();
    });
  }

  handleScrollDirectionChange() {
    const currentScrollTop = $(window).scrollTop();

    // Don't hide header at the top of the page
    if (currentScrollTop < this.scrollThreshold) {
      this.$header.removeClass(this.classes.headerHidden);
      this.lastScrollTop = currentScrollTop;
      return;
    }

    // Only hide header after it's pinned AND scrolled past secondary menu
    // (announcement + secondary menu height)
    if (currentScrollTop < this.totalHeaderHeight) {
      this.$header.removeClass(this.classes.headerHidden);
      this.lastScrollTop = currentScrollTop;
      return;
    }

    // Calculate scroll delta
    const scrollDelta = currentScrollTop - this.lastScrollTop;

    // Need minimum movement to trigger (avoid micro scrolls)
    if (Math.abs(scrollDelta) < 5) {
      return;
    }

    // Scroll down - hide header
    if (scrollDelta > 10) {
      this.$header.addClass(this.classes.headerHidden);
    } else if (scrollDelta < 0) {
      this.$header.removeClass(this.classes.headerHidden);
    } else {
      // No change
    }

    this.lastScrollTop = currentScrollTop;
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  controlSearchHeader() {
    this.$openSearch.on('click', () => {
      if (this.$header.hasClass(this.classes.menuOpen)) {
        this.$header.find('.js-hamburger').trigger('click');
      }
      this.$search.toggleClass(this.classes.active);
      this.$header.toggleClass(this.classes.searchActive);

      if (this.$search.hasClass(this.classes.active)) {
        this.$header.find('.form-control').focus();
      }
    });
    $(document).on('click.header', (e) => {
      const $target = $(e.target);
      if (!$target.closest('.header__search, .js-open-search').length && !$target.is('.open-header')) {
        this.$search.removeClass(this.classes.active);
        this.$header.removeClass(this.classes.searchActive);
      }
    });

    this.$searchInput.on('keyup', (e) => {
      this.$clearSearch.toggleClass(this.classes.disabled, !e.target.value);
      this.$searchBtn.toggleClass(this.classes.pointerEventNone, !e.target.value);
    });

    this.$clearSearch.on('click', () => {
      this.$searchInput.val('');
      this.$clearSearch.addClass(this.classes.disabled);
      this.$searchBtn.addClass(this.classes.pointerEventNone);
    });
    this.$closeSearch.on('click', () => {
      this.$search.removeClass(this.classes.active);
      this.$header.removeClass(this.classes.searchActive);
    });

    this.$headerForm.on('submit', (e) => {
      if (!this.$searchInput.val().trim()) {
        e.preventDefault();
      }
    });

    this.$searchBtn.on('click', (e) => {
      if (!this.$searchInput.val().trim()) {
        this.$searchBtn.addClass(this.classes.pointerEventNone);
        e.preventDefault();
      } else {
        this.$searchBtn.removeClass(this.classes.pointerEventNone);
      }
    });
  }

  settingPin() {
    this.scrollTop = $(window).scrollTop();
    // Pin header when scrolled past the announcement bar
    // Secondary menu is inside header, so it gets pinned together
    this.$header.toggleClass(this.classes.pin, this.scrollTop >= this.heightAnnouncement);
  }

  destroy() {
    $(window).off('.header');
    $(document).off('.header');
    this.$openSearch.off();
    this.$searchInput.off();
    this.$clearSearch.off();
    this.$headerForm.off();
    this.$searchBtn.off();
  }
}

const header = new Header();
header.init();
